import { render, staticRenderFns } from "./InquiriesType.vue?vue&type=template&id=5aeb2c35&"
import script from "./InquiriesType.vue?vue&type=script&lang=ts&"
export * from "./InquiriesType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports